import SymbolIconsMapper from './symbol-icons-mapper';

export default SymbolIconsMapper;
